export const COMMON_MUTATION_RESULT_FIELDS = {
  isSuccess: true,
  error: {
    code: true,
    message: true,
    detail: true,
  },
};
